export default "__VITE_ASSET__CY$cLh4B__"